import { effect, inject, Injectable, signal } from '@angular/core';
import { TestingAccessService } from './testing-access.service';

@Injectable({
    providedIn: 'root',
})
export class VerifyTimeoutToggleService {
    private readonly STORAGE_KEY = 'isi-dtc-verify-timeout-forced';
    private testingAccess = inject(TestingAccessService);

    enabled = signal<boolean>(false);

    constructor() {
        if (this.testingAccess.isEnabled()) {
            this.initializeState();

            effect(() => {
                localStorage.setItem(this.STORAGE_KEY, this.enabled() ? '1' : '0');
            });
        }
    }

    private initializeState(): void {
        const stored = localStorage.getItem(this.STORAGE_KEY);
        if (stored === '1') {
            this.enabled.set(true);
        }
    }

    toggle(): void {
        this.enabled.update((value) => !value);
    }
}
